/* eslint-disable @typescript-eslint/no-explicit-any */
import { MenuItem as MuiMenuItem, MenuItemProps as MuiMenuItemProps } from '@material-ui/core';
import { forwardRef } from 'react';
import { menuItemRoot } from 'ui/MenuItem/menuItemCssDefs';

/**
 * A styled MenuItem component
 * @see {@link https://material-ui.com/api/menu-item/} Material API docs for props
 * https://github.com/mui-org/material-ui/issues/16245 => override bug
 * https://material-ui.com/guides/typescript/#usage-of-component-prop => known and documented component.
 * We need to figure out what to do with OverridableComponents.
 * Once we do, this should use MUI MenuItemProps instead of explicitly and partially declaring them here.
 */

// extends MuiMenuItemProps<'li', { button?: true }>,
export interface MenuItemProps extends MuiMenuItemProps {
  onClick?(e: React.MouseEvent): void;
  selected?: boolean;
  component?: unknown;
  button?: any;
}

const MenuItem = forwardRef<unknown, MenuItemProps>(
  ({ children, component = 'li', button = false, ...rest }, ref) => {
    return (
      <MuiMenuItem
        {...rest}
        ref={ref}
        component={component as any}
        css={menuItemRoot}
        button={button}
      >
        {children}
      </MuiMenuItem>
    );
  }
);

export default MenuItem;
